import { NgClass } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { isObject } from 'lodash-es';

import { SiteOption } from '@models/site-option.model';
import { SitesQuery } from '@models/sites/sites.query';

import { MultiSelectDropdownComponent } from '@shared/components/multi-select-dropdown/multi-select-dropdown.component';
import {
  injectNgControl,
  NoopValueAccessorDirective,
} from '@shared/directives/noop-value-accessor.directive';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

@Component({
  hostDirectives: [NoopValueAccessorDirective],
  imports: [
    MultiSelectDropdownComponent,
    ReactiveFormsModule,
    NgClass,
    NgSelectModule,
    TooltipDirective,
  ],
  selector: 'aux-site-select-dropdown',
  styleUrls: ['./site-select-dropdown.component.scss'],
  templateUrl: './site-select-dropdown.component.html',
})
export class SiteSelectDropdownComponent {
  siteQuery = inject(SitesQuery);

  ngControl = injectNgControl();

  multipleDropdownClassNames = computed(() => {
    let classNames = 'site-dropdown';

    if (this.menuPanelWidth() === 'auto') {
      classNames += ' menu-auto-width ';
    }

    if (this.menuPosition() === 'left') {
      classNames += ' menu-left ';
    }

    return classNames.trim();
  });

  /**
   * Note: This works only for single site selection.
   */
  appendTo = input<string>('');
  label = input('Site:');
  loading = input(false);
  menuPanelWidth = input<'auto' | 'full'>('auto');
  menuPosition = input<'left' | 'right'>('right');
  multiple = input(true);
  placeholder = input('Select');
  titleKey = input<'name' | 'site_no'>('site_no');

  siteOptions = this.siteQuery.selectSiteOptions();

  getCustomOptionLabel = (option: unknown) => {
    if (this.isSiteOption(option)) {
      return this.titleKey() === 'site_no' ? option.title : option.siteName;
    }

    return '';
  };

  private isSiteOption = (option: unknown): option is SiteOption => {
    return isObject(option) && 'textToSearch' in option;
  };

  searchFn = (term: string, item: SiteOption) => {
    return item.textToSearch.toLocaleLowerCase().includes(term.toLocaleLowerCase());
  };
}
